import jQuery from 'jquery';
import showSandboxMessage from './sandbox-modal';
import {tooltips} from './sandbox-config';
import {attachTooltips} from 'comp/tooltip';

const addLogoButtonEvent = () => {
  jQuery('.editor-header-logo').click((ev) => {
    ev.preventDefault();
    showSandboxMessage('logo');
  });
};

const addOverviewButtonEvent = () => {
  jQuery('.page-overview-header-button').click((ev) => {
    ev.preventDefault();
    showSandboxMessage('overview');
  });
};

const disablePageName = () => {
  jQuery('.page-name .crumb-link').addClass('dsbl');
  jQuery('.page-name .crumb-link').click((ev) => {
    ev.preventDefault();
  });
};

const disableHeaderBar = () => {
  addLogoButtonEvent();
  addOverviewButtonEvent();
  disablePageName();
};

const showModal = (iframeSource) => {
  showSandboxMessage(iframeSource);
};

const initTooltips = (toolTipList = tooltips) => {
  attachTooltips(toolTipList);
};

export {
  disableHeaderBar,
  showModal,
  initTooltips
};



// WEBPACK FOOTER //
// ./src/control/sandbox/sandbox.js